import { render } from "./invest.vue?vue&type=template&id=0cc9ef7f&scoped=true"
import script from "./invest.vue?vue&type=script&lang=js"
export * from "./invest.vue?vue&type=script&lang=js"

import "./invest.vue?vue&type=style&index=0&id=0cc9ef7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc9ef7f"]])

export default __exports__